// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class ReferralInviteRequest {
  readonly emailBody: string;
  readonly emailSubject: string;
  readonly recipientName: string;
  readonly recipientEmail: string;

  constructor(data: { [key: string]: any } = {}) {
    this.emailBody = data.emailBody === undefined ? '' : data.emailBody;
    this.emailSubject = data.emailSubject === undefined ? '' : data.emailSubject;
    this.recipientName = data.recipientName === undefined ? '' : data.recipientName;
    this.recipientEmail = data.recipientEmail === undefined ? '' : data.recipientEmail;
  }

  static zero(): ReferralInviteRequest {
    const zeroValues: ExcludeMethodsDeep<ReferralInviteRequest> = {
      emailBody: '',
      emailSubject: '',
      recipientName: '',
      recipientEmail: '',
    };
    return new ReferralInviteRequest(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReferralInviteRequestWireFormat = {
  emailBody: string;
  emailSubject: string;
  recipientName: string;
  recipientEmail: string;
};

type NewReferralInviteRequestProps = PartialDeep<
  ReferralInviteRequest,
  { recurseIntoArrays: true }
>;
export const NewReferralInviteRequest: (
  props: NewReferralInviteRequestProps,
) => ReferralInviteRequest = (props) => new ReferralInviteRequest(props);

type NewReferralInviteRequestFromWireFormatProps = PartialDeep<
  ReferralInviteRequestWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReferralInviteRequestFromWireFormat: (
  props: NewReferralInviteRequestFromWireFormatProps,
) => ReferralInviteRequest = (props) => new ReferralInviteRequest(props);
